/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SpaceModalContent } from './SpaceModalContent';
import {
    SpaceModalContentFromJSON,
    SpaceModalContentFromJSONTyped,
    SpaceModalContentToJSON,
    SpaceModalContentToJSONTyped,
} from './SpaceModalContent';
import type { FuelUpSpaceType } from './FuelUpSpaceType';
import {
    FuelUpSpaceTypeFromJSON,
    FuelUpSpaceTypeFromJSONTyped,
    FuelUpSpaceTypeToJSON,
    FuelUpSpaceTypeToJSONTyped,
} from './FuelUpSpaceType';

/**
 * 
 * @export
 * @interface FuelUpBoardSpace
 */
export interface FuelUpBoardSpace {
    /**
     * Position on board (0-47)
     * @type {number}
     * @memberof FuelUpBoardSpace
     */
    position: number;
    /**
     * 
     * @type {FuelUpSpaceType}
     * @memberof FuelUpBoardSpace
     */
    spaceType: FuelUpSpaceType;
    /**
     * Display name of the space
     * @type {string}
     * @memberof FuelUpBoardSpace
     */
    name: string;
    /**
     * Space description
     * @type {string}
     * @memberof FuelUpBoardSpace
     */
    description?: string;
    /**
     * Fuel cost to activate this space
     * @type {number}
     * @memberof FuelUpBoardSpace
     */
    cost: number;
    /**
     * Array of RewardConfig IDs for this space
     * @type {Array<string>}
     * @memberof FuelUpBoardSpace
     */
    rewardConfigIds?: Array<string>;
    /**
     * Whether this space starts a new zone
     * @type {boolean}
     * @memberof FuelUpBoardSpace
     */
    isZoneStart?: boolean;
    /**
     * Which zone this space belongs to (1-4)
     * @type {number}
     * @memberof FuelUpBoardSpace
     */
    zoneId?: number;
    /**
     * Whether this is a premium spot (vs standard)
     * @type {boolean}
     * @memberof FuelUpBoardSpace
     */
    isPremium?: boolean;
    /**
     * Icon identifier for this space type
     * @type {string}
     * @memberof FuelUpBoardSpace
     */
    iconKey?: string;
    /**
     * URL to uploaded custom icon (CDN)
     * @type {string}
     * @memberof FuelUpBoardSpace
     */
    iconUrl?: string;
    /**
     * Hex color code for space (e.g., "#FF6B2C")
     * @type {string}
     * @memberof FuelUpBoardSpace
     */
    color?: string;
    /**
     * 
     * @type {SpaceModalContent}
     * @memberof FuelUpBoardSpace
     */
    modalContent?: SpaceModalContent;
    /**
     * Reference to FuelUpVaultBonusTier (for vault spaces)
     * @type {string}
     * @memberof FuelUpBoardSpace
     */
    vaultBonusTierId?: string;
    /**
     * Reference to FuelUpGasStationBonus (for gas station spaces)
     * @type {string}
     * @memberof FuelUpBoardSpace
     */
    gasStationBonusId?: string;
    /**
     * Reference to FuelUpSpinWheelConfig (for spin wheel spaces)
     * @type {string}
     * @memberof FuelUpBoardSpace
     */
    spinWheelConfigId?: string;
}



/**
 * Check if a given object implements the FuelUpBoardSpace interface.
 */
export function instanceOfFuelUpBoardSpace(value: object): value is FuelUpBoardSpace {
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('spaceType' in value) || value['spaceType'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('cost' in value) || value['cost'] === undefined) return false;
    return true;
}

export function FuelUpBoardSpaceFromJSON(json: any): FuelUpBoardSpace {
    return FuelUpBoardSpaceFromJSONTyped(json, false);
}

export function FuelUpBoardSpaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUpBoardSpace {
    if (json == null) {
        return json;
    }
    return {
        
        'position': json['position'],
        'spaceType': FuelUpSpaceTypeFromJSON(json['spaceType']),
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'cost': json['cost'],
        'rewardConfigIds': json['rewardConfigIds'] == null ? undefined : json['rewardConfigIds'],
        'isZoneStart': json['isZoneStart'] == null ? undefined : json['isZoneStart'],
        'zoneId': json['zoneId'] == null ? undefined : json['zoneId'],
        'isPremium': json['isPremium'] == null ? undefined : json['isPremium'],
        'iconKey': json['iconKey'] == null ? undefined : json['iconKey'],
        'iconUrl': json['iconUrl'] == null ? undefined : json['iconUrl'],
        'color': json['color'] == null ? undefined : json['color'],
        'modalContent': json['modalContent'] == null ? undefined : SpaceModalContentFromJSON(json['modalContent']),
        'vaultBonusTierId': json['vaultBonusTierId'] == null ? undefined : json['vaultBonusTierId'],
        'gasStationBonusId': json['gasStationBonusId'] == null ? undefined : json['gasStationBonusId'],
        'spinWheelConfigId': json['spinWheelConfigId'] == null ? undefined : json['spinWheelConfigId'],
    };
}

export function FuelUpBoardSpaceToJSON(json: any): FuelUpBoardSpace {
    return FuelUpBoardSpaceToJSONTyped(json, false);
}

export function FuelUpBoardSpaceToJSONTyped(value?: FuelUpBoardSpace | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'position': value['position'],
        'spaceType': FuelUpSpaceTypeToJSON(value['spaceType']),
        'name': value['name'],
        'description': value['description'],
        'cost': value['cost'],
        'rewardConfigIds': value['rewardConfigIds'],
        'isZoneStart': value['isZoneStart'],
        'zoneId': value['zoneId'],
        'isPremium': value['isPremium'],
        'iconKey': value['iconKey'],
        'iconUrl': value['iconUrl'],
        'color': value['color'],
        'modalContent': SpaceModalContentToJSON(value['modalContent']),
        'vaultBonusTierId': value['vaultBonusTierId'],
        'gasStationBonusId': value['gasStationBonusId'],
        'spinWheelConfigId': value['spinWheelConfigId'],
    };
}

